<div class="padT24 padL16">
  <h2 class="h2Header" name="headerIndentProcess">
    <strong> Parser Report </strong>
  </h2>
</div>

<div class="row marTB8 padT8 padL16" [ngStyle]="{ width: '100%' }">
  <div class="col-3">
    <form>
      <mat-form-field class="custom-form-field">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="From Date"
          (click)="picker.open()"
          [formControl]="fromDate"
          name="fromDate"
          (ngModelChange)="clearTo()"
          readonly
        />
        <mat-icon matSuffix style="cursor: pointer" (click)="picker.open()" name="calendarIcon">
          <img src="assets/images/icons/default_icons/icon-calendar.png" alt="calendar" />
        </mat-icon>
        <mat-datepicker #picker touchUi> </mat-datepicker>
      </mat-form-field>
    </form>
  </div>

  <div class="col-3">
    <form>
      <mat-form-field class="custom-form-field">
        <input
          matInput
          [matDatepicker]="pickerTo"
          [min]="setMin()"
          placeholder="To Date"
          (click)="pickerTo.open()"
          [formControl]="toDate"
          name="To Date"
          readonly
        />
        <mat-icon matSuffix style="cursor: pointer" (click)="pickerTo.open()" name="calendarIcon">
          <img src="assets/images/icons/default_icons/icon-calendar.png" alt="calendar" />
        </mat-icon>
        <mat-datepicker #pickerTo touchUi> </mat-datepicker>
      </mat-form-field>
    </form>
  </div>

  <span class="pad16">
    <button
      mat-flat-button
      class="primary-btn"
      (click)="startSearch()"
      id="btn-startSearch"
      [disabled]="disableSearch()"
    >
      Search
    </button>
  </span>
  <span *ngIf="recordSearched && dataSource.data.length > 0" class="pad16">
    <button mat-raised-button name="dbAdmindownload" class="Icon-Btn widhie38" (click)="exportTOExcel()">
      <img class="padL6" src="assets/images/webIcons/default_icons/download (1).png" alt="download (1)" />
    </button>
  </span>
</div>
<mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="recordSearched && dataSource.data.length > 0">
  <ng-container matColumnDef="fileName">
    <mat-header-cell *matHeaderCellDef id="label-fileName"> File Name </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="fileName-{{ index }}"> {{ element.fileName }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef id="label-status"> Status </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index" class="status-styling">
      <span id="status-{{ index }}"> {{ element.status }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="referenceCode">
    <mat-header-cell *matHeaderCellDef id="label-referenceCode"> Reference Code </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="referenceCode-{{ index }}"> {{ element.referenceCode }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="applicationSource">
    <mat-header-cell *matHeaderCellDef id="label-applicationSource"> Application Source </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="applicationSource-{{ index }}"> {{ element.applicationSource }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="unitcode">
    <mat-header-cell *matHeaderCellDef id="label-unitcode"> Unit Code </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="unitcode-{{ index }}"> {{ element.unitcode }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="createdBy">
    <mat-header-cell *matHeaderCellDef id="label-createdBy"> Created By </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index" class="userName-styling">
      <span id="createdBy-{{ index }}" [matTooltip]="element.createdBy"> {{ element.createdBy }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="createdDate">
    <mat-header-cell *matHeaderCellDef id="label-createdDate"> Max Queue Time </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="createdDate-{{ index }}"> {{ element.createdDate }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="updatedBy">
    <mat-header-cell *matHeaderCellDef id="label-updatedBy"> Updated By </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index" class="userName-styling">
      <span id="updatedBy-{{ index }}" [matTooltip]="element.updatedBy"> {{ element.updatedBy }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="updatedDate">
    <mat-header-cell *matHeaderCellDef id="label-updatedDate"> Updated Date </mat-header-cell>
    <mat-cell *matCellDef="let element; let index = index">
      <span id="updatedDate-{{ index }}"> {{ element.updatedDate }}</span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
<div *ngIf="dataSource.data.length < 1 && recordSearched" class="customCard nomarT">
  <div class="col-4 offset-4 marTB8 noData padB24">
    <h5 class="H5Header marL16 marT32 center">
      <strong name="nodata">No Data Available</strong>
    </h5>
  </div>
</div>

<div class="pagination-container">
  <mat-paginator style="background: #fafafa" [hidden]="!dataSource.data.length" showFirstLastButtons [pageSize]="7">
  </mat-paginator>
</div>
